import styled, { css } from 'styled-components'

const commonInputStyles = css`
  ${({ theme }) => css`
    padding: ${theme.spacing(2)};
    font-size: 1.8rem;
    border: 0.1rem solid ${theme.palette.grey[500]};
    background-color: white;

    &.hasError {
      border-color: #da2f47;
    }

    &.withClear {
      padding-right: ${theme.spacing(7)};
    }

    &:hover {
      border-color: ${theme.palette.grey[900]};
    }

    &:focus {
      outline: 0.2rem solid #000;
      border-color: transparent;
    }
  `}
`

const TextField = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(0.75)};

    // For cleave inputs
    input {
      ${commonInputStyles}
    }
  `}
`

const InputWrapper = styled.div`
  position: relative;
  width: 100%;

  input {
    width: 100%;
  }
`

// For regular inputs
const Input = styled.input`
  ${commonInputStyles}
`

const Clear = styled.button.attrs({ type: 'button' })`
  ${({ theme }) => css`
    appearance: none;
    border: none;
    background-color: transparent;
    position: absolute;
    top: 50%;
    right: ${theme.spacing(2)};
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    padding: ${theme.spacing(0.25)} ${theme.spacing(0.5)};

    &:hover {
      background-color: ${theme.palette.grey[100]};
    }
  `}
`

const Hint = styled.div`
  margin: 0.4rem 0 0.8rem;
`

export default {
  TextField,
  InputWrapper,
  Input,
  Clear,
  Hint,
}
